import { DYNAMIC_PRODUCT } from './globalConstants';

export const isDynamicProduct = (data) => {
	return data === DYNAMIC_PRODUCT;
}